import { useEffect } from "react";

/**
 * Prevent accidental value changes on number inputs caused by mouse-wheel/trackpad scrolling.
 * Only prevents default when the hovered/target element is an `input[type="number"]` AND
 * it is the currently focused element.
 */
export default function useDisableNumberWheel() {
  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return;

    const isNumberInputFocused = (target) => {
      if (!(target instanceof Element)) return false;
      const input = target.closest?.('input[type="number"]');
      if (!input) return false;
      return document.activeElement === input;
    };

    const handler = (e) => {
      if (!isNumberInputFocused(e.target)) return;
      // Prevent browser from incrementing/decrementing on wheel scroll.
      e.preventDefault();
    };

    const events = ["wheel", "mousewheel", "DOMMouseScroll"];
    events.forEach((evt) =>
      document.addEventListener(evt, handler, { passive: false, capture: true })
    );

    return () => {
      events.forEach((evt) =>
        document.removeEventListener(evt, handler, { capture: true })
      );
    };
  }, []);
}

